import WixSDK from 'shared/utils/wix-sdk';
import debounce from 'core-decorators/lib/debounce';
import autobind from 'core-decorators/lib/autobind';
import { isMobileWidgetVisibleInViewPort } from 'widget/utils/widget';


export const visibleInViewPort = WrappedComponent => {

  class VisibleInViewPort extends React.Component {

    state = {
      isVisible: false,
    };

    componentWillMount() {
      this.check();
      WixSDK.addEventListener(WixSDK.Events.SCROLL, this.check);
    }

    componentWillUnmount() {
      WixSDK.removeEventListener(WixSDK.Events.SCROLL, this.check);
    }

    @autobind
    @debounce(400)
    check() {
      isMobileWidgetVisibleInViewPort()
        .then(this.updateVisibility);
    }

    @autobind
    updateVisibility(newIsVisible) {
      if (newIsVisible !== this.state.isVisible) {
        this.setState({
          isVisible: newIsVisible,
        });
      }
    }

    render() {
      return (
        <WrappedComponent {...this.props}
                          isVisibleInViewport={this.state.isVisible} />
      );
    }
  }

  VisibleInViewPort.WixWrappedComponent = WrappedComponent;

  return VisibleInViewPort;
};



// WEBPACK FOOTER //
// ./src/widget/components/mobile-carousel/visible-on-screen.js